import axios from 'axios'
import { Folder, UpdateFolderResponse } from '../../types/folder'
import { getExternalReference } from '../getExternalReference'

export const updateFolder = async (
  id: number,
  name: string
): Promise<Folder | null> => {
  try {
    const backendUrl = process.env.REACT_APP_BACKEND

    if (!backendUrl) {
      console.error('REACT_APP_BACKEND environment variable is not defined')
      return null
    }

    const token = localStorage.getItem('@realize: accessToken')
    if (!token) {
      console.error('No authorization token found')
      return null
    }

    const externalReference = getExternalReference(backendUrl)

    const formData = new FormData()
    formData.append('name', name)
    formData.append('external_reference', externalReference)

    const response = await axios.put<UpdateFolderResponse>(
      `${backendUrl}/n8n/mavis/folders/${id}`,
      formData,
      {
        params: {
          external_reference: externalReference
        },
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    )

    return response.data.data
  } catch (error) {
    console.error('Unexpected error:', error)
    return null
  }
}
